<template>
  <transition name="login">
    <div class="login">
      <div class="xf-login-register">
        <div class="xf-login-container ">
          <div class="clearfix">
            <div
              class="go-back iconfont iconfanhui fl"
              @click="goLogin"
              v-if="showFindPwd"
            ></div>
            <div
              class="go-back iconfont iconfanhui fl"
              v-if="!showFindPwd"
              style="color:#fff"
            ></div>
            <div
              class="logo-close iconfont iconguanbi fr"
              @click="closeLogin"
            ></div>
            <div class="login-title">{{ title }}</div>
          </div>

          <!-- 登录框 -->
          <!-- <transition name="findpwd" mode="out-in"> -->
          <div class="login-input" v-if="!showFindPwd">
            <div class="input-username">
              <!-- <span>用户名:</span>
              <input
                type="text"
                v-model="username"
                placeholder="用户名"
                class="reset-input"
              /> -->
              <el-input
                placeholder="用户名"
                prefix-icon="el-icon-user"
                v-model="username"
              >
              </el-input>
            </div>
            <div class="input-pwd">
              <!-- <span>密 码</span>
              <label>:</label>
              <input
                type="password"
                v-model="password"
                placeholder="密码"
                @keyup.enter="login"
                class="reset-input"
              /> -->
              <el-input
                type="password"
                placeholder="密码"
                prefix-icon="el-icon-lock"
                v-model="password"
                @keyup.enter="login"
              >
              </el-input>
            </div>
            <div class="login-btns">
              <button class="login-btn" @click="login">立即登录</button>
            </div>
            <div class="login-group">
              <span class="login-remenber-pwd">
                <input
                  type="checkbox"
                  class="rember-checkbox reset-input"
                  ref="checkbox"
                />
                <span>记住密码</span>
              </span>
              <span class="jump-group">
                <a
                  class="forget-pwd"
                  href="https://www.icve.com.cn/portal/resetPassword.html?dataSource=7"
                  target="blank"
                  >忘记密码</a
                >
                <span class="login-split">|</span>
                <span class="register">
                  <a
                    href="https://www.icve.com.cn/portal/register/register.html?dataSource=7"
                    >注册</a
                  >
                </span>
              </span>
            </div>
          </div>
          <!-- </transition> -->
          <!-- 忘记密码 -->
          <!-- <transition name="findpwd" mode="out-in"> -->
          <div
            class="login-find-password"
            v-if="showFindPwd && statusCode === -1"
          >
            <div class="input-username">
              <!-- <span>用户名:</span>
                <input
                  type="text"
                  v-model="username"
                  class="reset-input reset-username"
                  placeholder="用户名"
                /> -->
              <el-input
                placeholder="用户名"
                prefix-icon="el-icon-user"
                v-model="username"
              >
              </el-input>
            </div>
            <div class="phone-country">
              <!-- <span class="phone-text">手机号:</span> -->
              <vue-tel-input
                v-model="phone"
                defaultCountry="cn"
                placeholder="手机号"
                :enabledCountryCode="true"
                @validate="phone1"
              ></vue-tel-input>
            </div>
            <!-- 图文验证码暂时注释 -->
            <!-- <div class="phone-code" style="text-align: right;">
                <input
                  type="text"
                  v-model="verifyCode"
                  placeholder="请输入验证码"
                  class="reset-input"
                  style="float: unset;"
                />
                <div class="verify-wrapper" @click="changeRandom">
                  <img
                    :src="'/api/portal/loginMooc/getVerifyCode?t=' + random"
                    alt=""
                  />
                </div>
              </div> -->
            <div class="phone-code">
              <!-- <span class="phone-text">验证码:</span>
                <input
                  type="text"
                  v-model="code"
                  placeholder="手机验证码"
                  class="reset-input"
                /> -->
              <el-input
                placeholder="验证码"
                prefix-icon="el-icon-message"
                style="width: 280px!important;"
                v-model="code"
              >
              </el-input>
              <button
                class="get-code-btn"
                @click="getCodeFind"
                v-if="showGetCode"
              >
                点击获取
              </button>
              <button
                class="get-code-btn btn-disabled"
                disabled
                v-if="!showGetCode"
              >
                {{ second }}秒后重新发送
              </button>
              <div class="clear"></div>
            </div>
            <!-- <div class="phone-submit" @click="getPwd">找回密码</div> -->
            <el-button
              type="danger"
              @click="getPwd"
              style="width:100%; background: #bc002d"
              >找回密码</el-button
            >
          </div>
          <!-- </transition> -->
          <!-- 状态-300 -->
          <!-- <transition name="findpwd" mode="out-in"> -->
          <div class="login-find-password bdphone" v-if="statusCode === -300">
            <div class="input-username">
              <el-input
                placeholder="用户名"
                prefix-icon="el-icon-user"
                v-model="username"
              >
              </el-input>
            </div>
            <div class="phone-country">
              <vue-tel-input
                v-model="phone"
                defaultCountry="cn"
                placeholder="手机号"
                :enabledCountryCode="true"
                @validate="phone1"
              ></vue-tel-input>
            </div>
            <div class="phone-code" style="text-align: right;">
              <input
                type="text"
                v-model="verifyCode"
                placeholder="请输入验证码"
                class="reset-input"
              />
              <div class="verify-wrapper" @click="changeRandom">
                <img
                  :src="'/api/common/login/getVerifyCode?t=' + random"
                  alt=""
                />
              </div>
            </div>
            <div class="phone-code">
              <input
                type="text"
                v-model="code"
                placeholder="手机验证码"
                class="reset-input"
              />
              <button class="get-code-btn" @click="getCode" v-if="showGetCode">
                点击获取
              </button>
              <button
                class="get-code-btn btn-disabled"
                disabled
                v-if="!showGetCode"
              >
                {{ second }}秒后重新发送
              </button>
              <div class="clear"></div>
            </div>
            <div class="phone-submit" @click="bindPhone">确定</div>
          </div>
          <!-- </transition> -->
          <!-- 状态-500 -->
          <!-- <transition name="findpwd" mode="out-in"> -->
          <div class="person-info" v-if="statusCode === -500">
            <!-- <div class="input-username">
              <span class="two-letter">院校</span>
              <label class="two-letter-icon">:</label>
              <el-select
                v-model="query"
                filterable
                clearable
                remote
                placeholder="院校"
                :remote-method="remoteMethod"
                popper-class="resetDrop"
                @change="getSelectItem"
              >
                <el-option
                  v-for="item in schools"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div> -->
            <div class="input-username">
              <span class="two-letter">姓名</span>
              <label class="two-letter-icon">:</label>
              <input
                type="text"
                v-model="name"
                class="reset-input reset-username"
                placeholder="姓名"
              />
            </div>
            <div class="input-username">
              <span>新密码:</span>
              <input
                type="password"
                v-model="newPwd"
                class="reset-input reset-username"
                placeholder="新密码"
              />
            </div>
            <div style="margin-top: 10px;text-align: left;color: red;font-size: 10px;">密码设置至少8位，由大、小写字母、数字、特殊字符（!@#$%^&*()_+-=）任意三种组成</div>
            <div class="input-username">
              <span class="four-letter">确认密码:</span>
              <input
                type="password"
                v-model="surePwd"
                class="reset-input reset-username"
                placeholder="确认密码"
              />
            </div>
            <div class="phone-country">
              <span class="phone-text">手机号:</span>
              <vue-tel-input
                v-model="phone"
                defaultCountry="cn"
                placeholder="手机号"
                :enabledCountryCode="true"
                @validate="phone1"
              ></vue-tel-input>
            </div>
            <div class="phone-code" style="text-align: left;">
              <input
                type="text"
                v-model="verifyCode"
                placeholder="请输入验证码"
                class="reset-input"
                style="float: unset;"
              />
              <div class="verify-wrapper" @click="changeRandom">
                <img
                  :src="'/api/common/login/getVerifyCode?t=' + random"
                  alt=""
                />
              </div>
            </div>
            <div class="phone-code">
              <span class="phone-text">验证码:</span>
              <input
                type="text"
                v-model="code"
                placeholder="验证码"
                style="width: 90px!important"
                class="reset-input"
              />
              <button class="get-code-btn" @click="getCode" v-if="showGetCode">
                点击获取
              </button>
              <button
                class="get-code-btn btn-disabled"
                disabled
                v-if="!showGetCode"
              >
                {{ second }}秒后重新发送
              </button>
              <div class="clear"></div>
            </div>
            <div class="phone-submit" @click="solveDanger">确定</div>
          </div>
          <!-- </transition> -->
          <!-- 状态-800 -->
          <transition name="findpwd" mode="out-in">
            <xf-radio-box
              v-if="statusCode === -800"
              @confirm="mergeUsername"
              :isShowCancel="false"
              :showRadioBox="showRadioBox"
              :firstName="firstName"
              :secondName="secondName"
              ref="radioBox"
              @close="close"
              @loginDeraction="close"
            ></xf-radio-box>
          </transition>
          <!-- 状态-900 -->
          <transition name="findpwd" mode="out-in">
            <div class="status900-contianer" v-if="statusCode === -900">
              <div class="top-content">
                系统检测到在智慧职教体系下，您可能还存在以下帐号。如确系您本人的帐号，请从下列用户中选择，我们将与您当前登录的用户进行合并。合并成功后，在当前帐号中能看到所有合并帐号的数据和功能，被合并帐号也将不能再登录;
                <label>帐号合并是不可逆的,请确认后再进行合并</label>
              </div>
              <div class="status900-contianer">
                <el-table
                  ref="multipleTable"
                  :data="userlist"
                  tooltip-effect="dark"
                  style="width: 100%;"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    type="selection"
                    width="35"
                  ></el-table-column>
                  <el-table-column label="帐号" width="120">
                    <template slot-scope="scope">{{
                      scope.row.UserName
                    }}</template>
                  </el-table-column>
                  <el-table-column prop="name" label="姓名" width="100">
                    <template slot-scope="scope">{{
                      scope.row.DisplayName
                    }}</template>
                  </el-table-column>
                  <el-table-column prop="address" label="帐号类型">
                    <template slot-scope="scope">{{
                      scope.row.UserType
                    }}</template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="phone-submit reset-submit-one" @click="combineAll">
                确定合并
              </div>
              <div class="phone-submit reset-submit-two" @click="combineNot">
                直接登录
              </div>
            </div>
          </transition>
          <hr class="hr-split" />
          <div class="third-login">
            <div class="third-login-text">第三方登录</div>
            <a
              href="https://www.icve.com.cn/commonUser/portal/wechatCode.html?dataSource=3"
            >
              <div class="iconfont iconweixin1 icon-reset"></div>
            </a>
          </div>
        </div>
        <xf-message-box
          @confirm="confirm"
          :isShowCancel="isShowCancel"
          :message="message"
          ref="messageBox"
        ></xf-message-box>
        <xf-message-box
          @confirm="mergeConfirm"
          :isShowCancel="false"
          :message="message"
          ref="mergeMessageBox"
        ></xf-message-box>
        <loading
          v-if="isShowLoading"
          iconColor="#c7092f"
          textColor="#c7092f"
          text="正在登录..."
        ></loading>
      </div>
    </div>
  </transition>
</template>
<script>
import { VueTelInput } from "vue-tel-input";
import xfMessageBox from "../xf-message-box/index";
import xfRadioBox from "../xf-radio-box/index";
import Cookies from "js-cookie";
import loading from "../loading";
export default {
  name: "xfLoginRegister",
  data() {
    return {
      //验证码
      verifyCode: "",
      //获取验证码的随机数
      random: "",
      // 用户名
      username: "",
      // 密码
      password: "",
      // 电话号码
      phone: "",
      // 验证码
      code: "",
      // 状态code 用与显示页面
      statusCode: -1,
      // 区号
      dialCode: "",
      //显示密码野蛮
      showFindPwd: false,
      // 验证码倒计时
      second: 60,
      //显示获取验证按钮的样式
      showGetCode: true,
      // messagebox 的消息
      message: "",
      // 是否显示messahebox的cancel按钮
      isShowCancel: false,
      // 用户缓存用户信息
      userInfo: [],
      // 学校列表
      schools: [],
      // 查询学校的条件
      query: "",
      // 存储学校的id
      schoolId: "",
      //新密码
      newPwd: "",
      //姓名
      name: "",
      //确认密码
      surePwd: "",
      // 用户类型
      userType: "",
      // 存储第一个用户名
      firstName: "",
      // 存储第二个用户名,
      secondName: "",
      // 获取选择的帐号
      selectUsername: "",
      // 是否显示raodiobox
      showRadioBox: true,
      // 合并帐号的ID，
      userId: "",
      // -900选择的id
      multipleSelection: [],
      // -900的帐号列表
      userlist: [],
      // 显示登录loading组件
      isShowLoading: false,
      timer: null,
      // 是否记住密码
      remenberFlag: "",
      savephone: false, //验证手机号是否正确
      title: "账号登录" //登录框标题
    };
  },
  props: {
    // 登录框logo
    logoImg: {
      type: String,
      default: ""
    }
  },
  components: {
    VueTelInput,
    xfMessageBox,
    xfRadioBox,
    loading
  },
  watch: {
    query() {
      this.getSchoolList();
    },
    username() {
      if (this.username === "") {
        this.password = "";
        this.$refs.checkbox.checked = false;
      }
    }
  },
  mounted() {
    this.getSchoolList();
    this.isRemenberMe();
    this.random = Math.random();
  },
  methods: {
    // 获取验证码
    phone1(phone) {
      this.phone = phone.number.international;
      this.savephone = phone.isValid;
    },
    // messagebox 的方法
    confirm() {
      this.$refs.messageBox.close();
    },
    // 等待时间获取验证码
    waitSecond() {
      this.showGetCode = false;
      let timer = null;
      clearInterval(timer);
      timer = setInterval(() => {
        this.second -= 1;
        if (this.second <= 1) {
          this.second = 60;
          this.showGetCode = true;
          clearInterval(timer);
        }
      }, 1000);
    },
    // 提交关闭登录事件
    closeLogin() {
      let dom = document.body;
      dom.style.overflowY = "auto";
      if (this.statusCode === -900) {
        this.combineNot();
      }
      this.$emit("closeLogin", false);
    },
    // 显示找回密码
    findPwd() {
      this.showFindPwd = true;
      this.statusCode = -1;
      this.title = "找回密码";
    },
    goLogin() {
      this.showFindPwd = false;
      this.statusCode = 1;
      this.title = "账号登录";
    },
    // 登录
    login() {
      this.isShowLoading = true;
      this.remenberFlag = this.$refs.checkbox.checked;
      let flag = this.$http
        .post("/api/common/login/loginSystem", {
          userName: this.username,
          password: this.password
        })
        .then(data => {
          this.judgeDataCode(data.code, data);
        });
      flag.then(() => {
        this.isShowLoading = false;
      });
    },
    // 判断登录返回的判断
    judgeDataCode(dataCode, data) {
      switch (dataCode) {
        case -300:
          this.statusCode = -300;
          this.showFindPwd = true;
          this.title = "绑定手机号";
          this.$refs.messageBox.show();
          this.message = data.msg;
          break;
        case -500:
          this.showFindPwd = true;
          this.statusCode = -500;
          this.$refs.messageBox.show();
          this.message = data.msg;
          this.getSchoolList();
          break;
        case -600:
          this.$refs.messageBox.show();
          this.message = data.msg;
          this.statusCode = 1;
          this.userId = data.userId;
          this.getCombineStatus();
          break;
        case -800:
          this.statusCode = -800;
          this.userId = data.userId;
          this.firstName = data.firstUserName;
          this.secondName = data.secondUserName;
          this.showRadioBox = true;
          break;
        case -900:
          this.statusCode = -900;
          this.showFindPwd = true;
          this.userId = data.nowUserId;
          this.userlist = data.list;
          break;
        case -1:
        case -2:
        case -3:
        case -4:
        case -700:
          this.$refs.messageBox.show();
          this.message = data.msg;
          break;
        case 1:
          this.$emit("getUserInfo", data);
          this.userInfo = data;
          this.remenberMe();
          this.closeLogin();
          this.saveUserToLocal();
          break;
        default:
          break;
      }
    },
    // 绑定手机 -300
    bindPhone() {
      let phoneCopy = this.phone;
      let phoneCopyCode = this.phone;
      let phoneList = phoneCopy.replace(/\s+/g, "").replace("+86", "");
      this.dialCode = phoneCopyCode.split(" ")[0].replace("+", "");
      this.$http
        .get("/api/common/login/updateMobile", {
          params: {
            userName: this.username,
            password: this.password,
            mobile: phoneList,
            dialCode: this.dialCode,
            code: this.code
          }
        })
        .then(data => {
          if (data.code === 1) {
            this.$emit("getUserInfo", data);
            this.userInfo = data;
            this.remenberMe();
            this.saveUserToLocal();
            this.closeLogin();
          } else {
            this.$refs.messageBox.show();
            this.message = data.msg;
          }
        });
    },
    // 绑定手机获取验证码
    getCode() {
      if (this.savephone === false) {
        return this.$message.error("请输入正确的手机号");
      }
      let phoneCopy = this.phone;
      phoneCopy = phoneCopy
        .replace(" ", "")
        .replace(" ", "")
        .replace(" ", "");
      // let phoneList = phoneCopy.replace(/\s+/g, "").replace("+86", "");
      // let reg = /^1[0-9]{10}$/;
      // if (!reg.exec(phoneList)) {
      //   this.$refs.messageBox.show();
      //   this.message = "手机格式不正确";
      //   return;
      // }
      this.$http
        .get("/api/common/login/sendInfo", {
          params: {
            mobile: phoneCopy,
            verifyCode: this.verifyCode
          }
        })
        .then(data => {
          if (data.code > 0) {
            this.waitSecond();
            this.$message.success(data.msg);
          } else {
            this.message = data.msg;
            this.$refs.messageBox.show();
          }
        });
    },
    // w忘记密码获取验证码
    getCodeFind() {
      if (this.savephone === false) {
        return this.$message.error("请输入正确的手机号");
      }
      let phoneCopy = this.phone;
      phoneCopy = phoneCopy
        .replace(" ", "")
        .replace(" ", "")
        .replace(" ", "");
      // let phoneList = phoneCopy.replace(/\s+/g, "").replace("+86", "");
      // let reg = /^1[0-9]{10}$/;
      // if (!reg.exec(phoneList)) {
      //   this.$refs.messageBox.show();
      //   this.message = "手机格式不正确";
      //   return;
      // }
      this.$http
        .get("/api/common/login/retrievePwdSendInfo", {
          params: {
            userName: this.username,
            mobile: phoneCopy,
            verifyCode: this.verifyCode
          }
        })
        .then(data => {
          if (data.code > 0) {
            this.waitSecond();
            this.$message.success(data.msg);
          } else {
            this.message = data.msg;
            this.$refs.messageBox.show();
          }
        });
    },
    // 找回密码
    getPwd() {
      let phoneCopy = this.phone;
      if (!phoneCopy) {
        this.$message.error("请输入手机号");
        return false;
      }
      let phoneList = phoneCopy.replace(/\s+/g, "").replace("+86", "");
      this.$http("/api/portal/loginmooc/retrievePwd", {
        params: {
          userName: this.username,
          mobile: phoneList,
          code: this.code
        }
      }).then(data => {
        if (data.code === 1) {
          this.$refs.messageBox.show();
          this.message = data.msg;
        } else {
          this.$refs.messageBox.show();
          this.message = data.msg;
        }
      });
    },
    // 获取学校列表
    getSchoolList(query) {
      this.$http("/api/common/login/getSelectSchoolList", {
        params: {
          q: query || ""
        }
      }).then(data => {
        if (data) {
          this.schools = data;
        }
      });
    },
    // selec 的回调函数t
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.getSchoolList(query);
        }, 200);
      } else {
        this.schools = [];
      }
    },
    // 暂时存储学校id
    getSelectItem() {
      this.schoolId = this.query;
    },
    // 解决帐号异常 -500
    solveDanger() {
      let phoneCopy = this.phone;
      let phoneCopyCode = this.phone;
      let phoneList = phoneCopy.replace(/\s+/g, "").replace("+86", "");
      this.dialCode = phoneCopyCode.split(" ")[0].replace("+", "");
      this.$http
        .get("/api/common/login/updateInfo", {
          params: {
            userName: this.username,
            oldPassword: this.password,
            newPassword: this.newPwd,
            againPassword: this.surePwd,
            schoolId: this.schoolId,
            mobile: phoneList,
            code: this.code,
            dialCode: this.dialCode,
            displayName: this.name
          }
        })
        .then(data => {
          if (data.code > 0) {
            this.$message.success("修改成功，请返回重新登录");
            // this.$refs.messageBox.show();
            // this.statusCode = 1;
            // this.showFindPwd = false;
            // this.password = "";
            this.closeLogin();
          } else {
            this.$refs.messageBox.show();
            this.message = data.msg;
          }
        });
    },
    // 记住密码
    remenberMe() {
      // let remenberFlag = this.$refs.checkbox.checked;
      if (this.remenberFlag) {
        let localStorageFlag = localStorage.getItem("remenberMe");
        if (!localStorageFlag || localStorageFlag == "false") {
          localStorage.setItem("remenberMe", true);
          localStorage.setItem("passWord", this.password);
          this.saveUserToLocal();
        } else {
          if (!localStorage.getItem("userName") !== this.username) {
            localStorage.setItem("passWord", this.password);
            this.saveUserToLocal();
          }
        }
      }
    },
    // 保存用户信息到localstorage
    saveUserToLocal() {
      // localStorage.setItem('remenberMe', true);
      // let remenberFlag = this.$refs.checkbox.checked;
      if (!this.remenberFlag) {
        localStorage.setItem("remenberMe", false);
        localStorage.setItem("passWord", "");
      }
      localStorage.setItem("userId", this.userInfo.userId || "");
      localStorage.setItem("userName", this.username || "");
      // localStorage.setItem('passWord', this.password);
      localStorage.setItem("displayName", this.userInfo.displayName || "");
      localStorage.setItem("avator", this.userInfo.avatorUrl || "");
      localStorage.setItem("userType", this.userInfo.userType.toString() || "");
      localStorage.setItem("schoolId", this.userInfo.schoolId || "");
      localStorage.setItem("schoolName", this.userInfo.schoolName || "");
      // localStorage.setItem(
      //   "isValidZjy",
      //   this.userInfo.isValidZjy.toString() || ""
      // );
      // localStorage.setItem(
      //   "isValidIcve",
      //   this.userInfo.isValidIcve.toString() || ""
      // );
      // localStorage.setItem(
      //   "isUnionManager",
      //   (this.userInfo.isUnionManager &&
      //     this.userInfo.isUnionManager.toString()) ||
      //     ""
      // );
      // localStorage.setItem(
      //   "isTinyMajorManager",
      //   (this.userInfo.isTinyMajorManager &&
      //     this.userInfo.isTinyMajorManager.toString()) ||
      //     ""
      // );

      let globalDomain = "mooc.icve.com.cn";
      let domainRegex = new RegExp(globalDomain);
      if (domainRegex.test(location.hostname)) {
        Cookies.set("token", this.userInfo.token, {
          path: "/",
          domain: globalDomain
        });
      } else {
        Cookies.set("token", this.userInfo.token, {
          path: "/",
          domain: location.hostname
        });
      }
    },
    // 登录判断是否记住密码
    isRemenberMe() {
      let localStorageFlag = localStorage.getItem("remenberMe");
      if (localStorageFlag == "true") {
        this.username = localStorage.getItem("userName");
        this.password = localStorage.getItem("passWord");
        this.$refs.checkbox.checked = localStorageFlag;
      } else {
        this.username = "";
        this.password = "";
        this.$refs.checkbox.checked = "";
      }
    },
    // 合并帐号 -800
    mergeUsername(value) {
      this.message = "您选择的帐号是" + value;
      this.selectUsername = value;
      if (!value) {
        this.message = "您还没选择帐号";
        this.$refs.messageBox.show();
        return;
      }
      this.$refs.mergeMessageBox.show();
    },
    // 合并帐号 -800
    mergeConfirm() {
      this.$http
        .get("/api/portal/loginmooc/saveUserName", {
          params: {
            userId: this.userId,
            userName: this.selectUsername,
            password: this.password
          }
        })
        .then(data => {
          if (data.code === 1) {
            this.$emit("getUserInfo", data);
            this.userInfo = data;
            this.$refs.mergeMessageBox.close();
            this.closeLogin();
            this.statusCode = 1;
            this.remenberMe();
            this.saveUserToLocal();
          } else {
            this.closeLogin();
            this.$refs.mergeMessageBox.close();
            this.$emit("combinFail", data.msg);
            this.statusCode = 1;
          }
        });
    },
    // 不选择帐号直接关闭 -800
    close() {
      this.$http
        .get("/api/common/login/noChooselogin", {
          params: { nowUserId: this.userId }
        })
        .then(data => {
          if (data.code === 1) {
            this.$emit("getUserInfo", data);
            this.userInfo = data;
            this.$refs.mergeMessageBox.close();
            this.closeLogin();
            this.statusCode = 1;
            this.remenberMe();
            this.saveUserToLocal();
          } else {
            this.$refs.messageBox.show();
            this.message = data.msg;
          }
        });
    },
    // 状态-600
    getCombineStatus() {
      this.timer = setInterval(() => {
        this.$http
          .get("/api/common/login/getCombineStatus", {
            params: {
              userId: this.userId
            }
          })
          .then(data => {
            if (data.code === 1) {
              this.$emit("combinFail", 1);
              clearInterval(this.timer);
            }
          });
      }, 2 * 60 * 1000);
    },
    // elments.的选择毁掉函数
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // -900合并多个
    combineAll() {
      if (!this.multipleSelection.length) {
        this.message = "请先选择你要合并的帐号";
        this.$refs.messageBox.show();
        return;
      }
      // 初始化选择用户的id
      let userChoiceIds = [];
      this.multipleSelection.forEach(item => {
        userChoiceIds.push(item.Id);
      });
      this.$http
        .get("/api/portal/loginmooc/chooseUserCombine", {
          params: {
            nowUserId: this.userId,
            chooseUserIds: userChoiceIds
          }
        })
        .then(data => {
          switch (data.code) {
            case -1:
            case -2:
            case -3:
            case -4:
              this.closeLogin();
              this.$emit("combinFail", data.msg);
              this.statusCode = 1;
              this.userId = data.userId;
              break;
            case -600:
              this.closeLogin();
              this.$emit("combinFail", data.msg);
              this.statusCode = 1;
              this.userId = data.userId;
              this.getCombineStatus();
              break;
            case 1:
              this.userInfo = data;
              this.closeLogin();
              this.remenberMe();
              this.saveUserToLocal();
              break;
            default:
              break;
          }
        });
    },
    // -900 不合并帐号直接登录
    combineNot() {
      this.$http
        .get("/api/portal/loginmooc/noChooselogin", {
          params: {
            nowUserId: this.userId
          }
        })
        .then(data => {
          if (data.code == 1) {
            this.$emit("getUserInfo", data);
            this.userInfo = data;
            this.closeLogin();
            this.remenberMe();
            this.saveUserToLocal();
            this.statusCode = 1;
          }
        });
    },
    changeRandom() {
      this.random = Math.random();
    }
  }
};
</script>
